import { getStatusInfo } from '@/utils/status';

type BadgeSize = 'sm' | 'md' | 'lg';

interface StatusBadgeProps {
  status: string;
  size?: BadgeSize;
}

const SIZE_MAP: Record<BadgeSize, string> = {
  sm: 'px-2 py-0.5 text-[11px]',
  md: 'px-2.5 py-1 text-xs',
  lg: 'px-3 py-1.5 text-sm',
};

export function StatusBadge({ status, size = 'md' }: StatusBadgeProps) {
  const { bg, text, label } = getStatusInfo(status);
  return (
    <span className={`inline-flex max-w-full items-center rounded-full font-semibold leading-tight text-center whitespace-normal text-safe-normal ${SIZE_MAP[size]} ${bg} ${text}`} title={label}>
      {label}
    </span>
  );
}
